import type { DemandPointModel, DemandWindowModel } from '@/shared/generated'

export const buildDemandSeries = (
	window: DemandWindowModel
): { points: DemandPointModel[]; windowStartIndex: number } => ({
	points: [...window.recent_history, ...window.segmentation_window],
	windowStartIndex: window.recent_history.length,
})

export const formatHistoryDuration = (
	days: number
): { value: number; unit: 'months' | 'weeks' } =>
	days >= 60
		? { value: Math.round(days / 30), unit: 'months' }
		: { value: Math.round(days / 7), unit: 'weeks' }
